export const EMPLOYMENT_STATUS_EMPLOYED = '108540';
export const EMPLOYMENT_STATUS_SELF_EMPLOYED = '102119';
export const EMPLOYMENT_STATUS_RETIRED = '102116';
export const EMPLOYMENT_STATUS_STUDENT = '102118';
export const EMPLOYMENT_STATUS_HOMEMAKER = '102117';
export const EMPLOYMENT_STATUS_UNEMPLOYED = '108539';
